@use '../../../../styles/Colors.scss' as Colors;
@use '../../../../styles/Constants.scss' as Constants;

.add-button-container {
	padding-top: Constants.$val-spacing-m;
	max-width: Constants.$val-serachBoxMaxWidth;
}

.vendor-list {
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: flex-start;
	margin: 0;
}

.vendor-list-container {
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-start;
}

.vendor-list-container-empty {
	color: Colors.$col-greyFontLight;
	font-weight: bold;
}

.vendor-list-container-wrapper {
	padding: Constants.$val-spacing-m;
	background-color: Colors.$col-white;
	box-shadow: Constants.$val-boxShadow;
}

.form {
	display: flex;
	flex-direction: row;
}